import { SCALE_MODES } from "@pixi/core";
import { Text, TextStyle, TextMetrics } from "@pixi/text";

export class FitText extends Text {
    private baseStyle: TextStyle;
    private autoFit: boolean;
    constructor(
        text: string,
        style: TextStyle,
        private readonly autoFitWidth: number | null,
        private readonly autoFitHeight: number | null
    ) {
        super(text, style);
        this.baseStyle = style.clone();
        this.autoFit = autoFitWidth != null || autoFitHeight != null;
        this.texture.baseTexture.scaleMode = SCALE_MODES.NEAREST;
    }

    private autoSizingTextStyle(style: TextStyle): TextStyle {
        const localStyle = style.clone();
        if ((this.autoFitWidth == null && this.autoFitHeight == null) || typeof localStyle.fontSize === "string" || localStyle.fontSize <= 1) {
            return localStyle;
        }

        const textMetrics = TextMetrics.measureText(this.text, localStyle);

        if (textMetrics.width <= this.autoFitWidth && textMetrics.height <= this.autoFitHeight) {
            return localStyle;
        }

        localStyle.fontSize--;

        return this.autoSizingTextStyle(localStyle);
    }

    public updateBaseStyle(style: TextStyle): void {
        this.baseStyle = style.clone();
    }

    override updateText(respectDirty: boolean): void {
        if (this.localStyleID !== this._style.styleID || this.dirty || !respectDirty) {
            if (this.autoFit && this.parent) {
                this.style = this.autoSizingTextStyle(this.baseStyle);
            } else {
                this.style.fontSize = this.baseStyle.fontSize;
            }
        }
        super.updateText(respectDirty);
    }
}
